import {
  getRaffleRewardClaimDeliveryType,
  getRaffleRewardClaimStatus,
} from "@hooks/functions/Raffle/rewardClaim";
import {
  RaffleRewardClaimDeliveryTypes,
  RaffleRewardClaimStatusTypes,
} from "@hooks/enums/raffle_reward_claim";

interface IStatusProps {
  status: RaffleRewardClaimStatusTypes;
}

interface IDeliveryTypeProps {
  deliveryType: RaffleRewardClaimDeliveryTypes;
}

export function RewardClaimStatusBadge({ status }: IStatusProps) {
  const currentStatus = getRaffleRewardClaimStatus(status);

  return (
    <span
      className={`badge bg-${currentStatus.color} text-white`}
      title={currentStatus.title}
      style={{ borderRadius: 8 }}
    >
      {currentStatus.text}
    </span>
  );
}

export function RewardClaimDeliveryTypeBadge({
  deliveryType,
}: IDeliveryTypeProps) {
  const currentDeliveryType = getRaffleRewardClaimDeliveryType(deliveryType);

  return (
    <span
      className={`badge bg-${currentDeliveryType.color} text-white`}
      title={currentDeliveryType.title}
      style={{ borderRadius: 8 }}
    >
      {currentDeliveryType.text}
    </span>
  );
}
